import React from 'react';
import LocationTemplate from './LocationTemplate';

const WhitevillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Whiteville"
      stateName="North Carolina"
      countyName="Columbus"
      zipCodes={["28472"]}
      latitude={34.3385}
      longitude={-78.7031}
      population={5394}
      historicalFact="County seat of Columbus County, incorporated in 1832 and named after early settler James B. White."
      nearbyTowns={[
        "Chadbourn, NC",
        "Tabor City, NC",
        "Fair Bluff, NC",
        "Bolton, NC",
        "Elizabethtown, NC",
        "Lumberton, NC",
        "Conway, SC",
        "Loris, SC"
      ]}
    />
  );
};

export default WhitevillePage;